import { render, staticRenderFns } from "./BackgroundOverviewStep.vue?vue&type=template&id=81b27624&"
import script from "./BackgroundOverviewStep.vue?vue&type=script&lang=js&"
export * from "./BackgroundOverviewStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports